import { render, staticRenderFns } from "./offline_purchase_list.vue?vue&type=template&id=4818d4ba&scoped=true"
import script from "./offline_purchase_list.vue?vue&type=script&lang=js"
export * from "./offline_purchase_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818d4ba",
  null
  
)

export default component.exports